import { UserRole } from '@ti/contracts'

export const HIDDEN_FLEET_ROLES = [
  UserRole.FleetFinance,
  UserRole.FleetDispatcher,
  UserRole.FleetMaintenance,
  UserRole.FleetInstaller,
  UserRole.FleetDemo,
]
